<template>
  <v-card
    light
    flat
    class="d-flex flex-column justify-space-between"
    rounded="xl"
    height="450px"
    style="transition: 0.3s all"
    :color="count > 0 ? 'primary' : null"
  >
    <div>
      <v-card-title class="pa-0">
        <v-img class="elevation-10 counter rounded-xl" height="200px" :src="orderItem.resim">
          <v-card-title :class="count > 0 ? 'pt-2' : null">
            <v-chip x-small color="grey">UK-000{{ orderItem.urun_kodu }}</v-chip>
            <v-spacer />

            <v-tooltip left color="error" v-if="count > 0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab color="primary" small @click="count = 0">
                  <v-icon color="grey">
                    {{ icons.mdiDelete }}
                  </v-icon>
                </v-btn>
              </template>

              <span>Sil</span>
            </v-tooltip>
          </v-card-title>
          <div v-if="!orderItem.resim" class="text-center" :class="count > 0 ? 'pt-4' : 'pt-7'">
            <v-icon size="48">{{ icons.mdiCameraOff }}</v-icon>
          </div>
        </v-img>
      </v-card-title>

      <v-card-text class="pt-3" :class="count > 0 ? 'white--text' : null">
        <div class="font-weight-bold d-flex align-center justify-space-between pt-2 pb-1 " style="font-size: 16px">
          <div>
            {{ orderItem.baslik }}
          </div>
          <v-btn icon @click="dialog = !dialog">
            <v-icon>{{ icons.mdiHelpCircle }}</v-icon>
          </v-btn>
        </div>

        <div class="mt-6 font-weight-bold text-overline" style="font-size: 16px !important">
          {{ orderItem.satis_fiyati | currency }}
        </div>
      </v-card-text>
    </div>

    <v-card-text>
      <v-row align="center" dense>
        <v-col md="5">
          <div class="d-flex align-center justify-space-between">
            <v-btn class="text-capitalize white--text" color="chip" fab small @click="countMinus()">
              <v-icon small>{{ icons.mdiMinusThick }}</v-icon>
            </v-btn>

            <v-btn
              class="text-capitalize white--text mr-1"
              color="chip"
              fab
              small
              @click="countPlus()"
            >
              <v-icon small>{{ icons.mdiPlusThick }}</v-icon>
            </v-btn>
          </div>
        </v-col>
        <v-col md="7">
          <v-text-field
            v-model.number="count"
            type="tel"
            background-color="counter"
            solo
            rounded
            :suffix="orderItem.birim"
            placeholder="0"
            persistent-placeholder
            flat
            hide-details
            outlined
            dense
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
    <v-dialog width="500" v-model="dialog">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2"> {{ orderItem.baslik }} </v-card-title>

        <v-card-text class="pt-5" v-html="orderItem.altBaslik" />

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false"> Kapat </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { ref, watch } from "@vue/composition-api";

import { mdiMinusThick, mdiHelpCircle, mdiPlusThick, mdiDelete, mdiCameraOff } from "@mdi/js";

export default {
  props: {
    orderItem: {
      type: Object,
      default: () => {},
    },
  },
  emits: ["countEvent"],
  setup(props, { emit }) {
    const count = ref(props.orderItem.quantity);
    const dialog = ref(false);
    watch(count, (val) => {
      if (val >= 0) {
        emit("countEvent", [val, props.orderItem.id]);
      }
      if (val === "") {
        emit("countEvent", [0, props.orderItem.id]);
        count.value = 0;
      }
    });

    const countMinus = () => {
      if (count.value > 0) {
        count.value--;
        emit("countEvent", [count.value, props.orderItem.id]);
      } else {
      }
    };

    const countPlus = (params) => {
      count.value++;
      emit("countEvent", [count.value, props.orderItem.id]);
    };

    return {
      count,
      dialog,
      countMinus,
      countPlus,

      icons: {
        mdiPlusThick,
        mdiMinusThick,
        mdiHelpCircle,
        mdiDelete,
        mdiCameraOff,
      },
    };
  },
};
</script>

<style lang="scss" scoped></style>
